/**
 * Bashkon përgjigjet `pi-alarms-energy-meter` dhe `/api/alarms` për një Energy Meter
 * (e njëjtë logjikë si në EnergyMeterDetail / EnergyMeterDetailChint).
 */
export function mergeEnergyMeterAlarmResponses(alarmsPiRes, alarmsApiRes) {
  const piAlarmsRaw = alarmsPiRes?.data?.alarms ?? [];
  const piAlarms = [];
  piAlarmsRaw.forEach((doc) => {
    const list = Array.isArray(doc?.payload?.alarms) ? doc.payload.alarms : [];
    list.forEach((a) => piAlarms.push({ ...a, _ts: doc?.ts }));
    if (list.length === 0 && doc?.payload && (doc.payload.name != null || doc.payload.message != null)) {
      piAlarms.push({ ...doc.payload, _ts: doc?.ts });
    }
  });
  const apiAlarms = Array.isArray(alarmsApiRes?.data) ? alarmsApiRes.data : [];
  const merged = apiAlarms.map((a) => ({
    name: a?.message,
    message: a?.message,
    state: a?.is_active ? 'ON' : 'OFF',
    ...a,
  }));
  piAlarms.forEach((a) => {
    if (
      !merged.some(
        (m) =>
          (m?.id && m.id === a?.id) ||
          (m?.no === a?.no && String(m?.name || '').trim() === String(a?.name || a?.message || '').trim()),
      )
    ) {
      merged.push(a);
    }
  });
  const alarmHistory = (piAlarmsRaw || []).map((doc) => {
    const pl = doc?.payload || {};
    const alarmsList = Array.isArray(pl.alarms) ? pl.alarms : [];
    const anyOn = alarmsList.some((x) => String(x?.state || '').toUpperCase() === 'ON');
    const diOn = [pl.di1, pl.di2, pl.di3, pl.di4].some(
      (v) => v === true || v === 1 || String(v).toLowerCase() === 'on' || v === '1',
    );
    const active = anyOn || diOn;
    return { ts: doc?.ts, active: !!active };
  });
  return { alarms: merged, alarmHistory };
}
